import axios from 'axios';

// Base URL setup
const API_URL = process.env.REACT_APP_API_ENDPOINT;
// Module path based on documentation: /json/api/dashboard/campaign-report
const MODULE_PATH = 'campaign-report';

export const getFilterOptions = async () => {
      // API 1: Get Campaign List & Snapshot Times
      // GET /json/api/dashboard/campaign-report/filter-options
      return await axios.get(`${API_URL}${MODULE_PATH}/filter-options`);
};

export const getDataStatistics = async (values) => {
      // API 2: Get Table Data
      // POST /json/api/dashboard/campaign-report/data-statistics
      return await axios.post(`${API_URL}${MODULE_PATH}/data-statistics`, values);
};

export const getGraphicalStatistics = async (values) => {
      // API 3: Get Chart Data
      // POST /json/api/dashboard/campaign-report/graphical-statistics
      return await axios.post(`${API_URL}${MODULE_PATH}/graphical-statistics`, values);
};

export const saveSnapshot = async (values) => {
      // API 4: Save Snapshot
      // POST /json/api/dashboard/campaign-report/save-snapshot
      return await axios.post(`${API_URL}${MODULE_PATH}/save-snapshot`, values);
};

export const refreshSnapshot = async (values) => {
      // API: Refresh (Preview)
      // POST /json/api/dashboard/campaign-report/refresh
      return await axios.post(`${API_URL}${MODULE_PATH}/refresh`, values);
};
